import { useKeycloak } from "@react-keycloak/web";

const PrivateRoute = ({children }: { children: JSX.Element }) => {
  
  const { keycloak, initialized } = useKeycloak();
  if (!initialized)
    return <div>Loading...</div>;

  return keycloak.authenticated ? children : <div>Authentication Failed.</div>;
};

export default PrivateRoute;